import React from "react";
import { Flex } from "antd";
import styled from "@emotion/styled";

import { PhoneField } from "@/components/ui/form/Fields";

export const CODE_EXPIRE_TIME = 5 * 60 * 1000; // 5분

export const SendButton = styled.div(({ theme, disabled }) => ({
  alignSelf: "stretch",
  background: disabled ? theme.color.grey05 : theme.color.primary01,
  wordBreak: "keep-all",
  whiteSpace: "nowrap",
  display: "flex",
  alignItems: "center",
  cursor: disabled ? "default" : "pointer",
  pointerEvents: disabled ? "none" : "auto",
  height: "4.4rem",
  borderRadius: "0.8rem",
  padding: "0 2rem",
  color: theme.color.black02,
}));

const PhoneVerificationFields = ({ control, setValue }) => {
  return (
    <>
      <Flex>
        <PhoneField control={control} setValue={setValue} />
      </Flex>

      {/* <Flex>
        <TextInput
          name="auth_code"
          label="인증번호"
          labelrequired="true"
          control={control}
          placeholder={VERIFICATION_CODE_PH}
          bordered={false}
          customborder="true"
          readOnly={codeVerified || !codeSent}
          inputMode="numeric"
          autoComplete="one-time-code"
          labelafter={
            <ErrorMessage
              custom={{
                display:
                  codeSent && !codeExpired && !codeVerified ? "block" : "none",
              }}
            >
              <div style={{ marginTop: "0.4rem" }}>
                <Countdown
                  date={targetDate}
                  renderer={renderer}
                  ref={timerRef}
                  autoStart={false}
                />
              </div>
            </ErrorMessage>
          }
          customerror={
            errors.phone_verified ? errors.phone_verified?.message : ""
          }
          addonAfter={
            <SendButton
              type="button"
              disabled={
                (!codeActive && !codeExpired) || codeVerified || isPending
              }
              onClick={codeExpired ? handleResendCode : handleVerifyCode}
            >
              {isPending ? (
                <Loading />
              ) : codeExpired ? (
                "재전송"
              ) : codeVerified ? (
                "인증 완료"
              ) : (
                "인증번호 확인"
              )}
            </SendButton>
          }
        />
      </Flex> */}
    </>
  );
};

export default PhoneVerificationFields;
